import { getTemplateById, TemplateDefinition, TemplateMetadata } from "@/config/templates";
import { buildTemplateSeed } from "@/lib/templateUtils";

export interface EditorInitializationState {
  content: string;
  metadata: TemplateMetadata;
  fields: Record<string, string>;
  title: string;
  tags: string[];
}

const buildDefaultFields = (template?: TemplateDefinition): Record<string, string> => {
  if (!template?.defaultFields) return {};

  return template.defaultFields.reduce<Record<string, string>>((acc, field) => {
    acc[field.id] = field.defaultValue ?? field.placeholder ?? "";
    return acc;
  }, {});
};

const buildTagsFromMetadata = (template?: TemplateDefinition): string[] => {
  if (!template?.defaultMetadata) return [];

  return Object.entries(template.defaultMetadata).reduce<string[]>((tags, [, value]) => {
    if (typeof value === "string" || typeof value === "number") {
      tags.push(String(value));
    }
    return tags;
  }, []);
};

export const buildEditorStateFromTemplate = (
  templateId: string | null,
): EditorInitializationState => {
  const template = templateId ? getTemplateById(templateId) : undefined;
  const { content, metadata } = buildTemplateSeed(templateId);

  return {
    content,
    metadata,
    fields: buildDefaultFields(template),
    title: template?.name ?? "",
    tags: buildTagsFromMetadata(template),
  };
};

export const initializeEditorFromTemplate = (templateId: string | null): EditorInitializationState =>
  buildEditorStateFromTemplate(templateId);

